<template>
	<div class="collapsable" ref="collapsable" :style=" { maxHeight: isOverflowing && !showAll ? maxHeight + 'px' : '' }">
		<slot></slot>
		<div v-if="isOverflowing && !showAll" class="collapsable__mask" :class="'collapsable__mask--' + background" @click="showAll = true">
			<div>{{showMoreText}}</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Collapsable',
		props: {
			maxHeight: {
				type: Number,
				default: 250,
			},
			showMoreText: {
				type: String,
				default: 'Lire la suite'
			},
			background: {
				type: String,
				default: 'white'
			},
			name: {
				type: String,
				default: 'Collapsed element'
			}
		},
		data: function() {
			return {
				isOverflowing: true,
				showAll: false,
				checked: false,
			}
		},
		mounted() {
			this.$nextTick(function() {
				const observer = new ResizeObserver(entries => {
					this.isOverflowing = entries[0].target.scrollHeight > this.maxHeight
				})
				observer.observe(this.$refs.collapsable)
			})

		},
		watch: {
			showAll: function() {
				this.$emit('expand')
			}
		}
	}
</script>
<style lang="scss">
	@import '../css/contexte.apps.fonts';
	.collapsable {
		position: relative;
		overflow: hidden;
		&__mask {
			font: 400 .8em $sans;
			cursor: pointer;
			text-decoration: underline;
			position: absolute;
			width: 100%;
			bottom: 0;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: flex-end;
			&--grey {			
				background: linear-gradient(
					rgba(246, 246, 246, 0) 0%,
					rgb(246, 246, 246) 90%,
					rgb(246, 246, 246) 100%
				);
			}
			&--white {
				background: linear-gradient(
					rgba(255, 255, 255, 0) 0%,
					rgb(255, 255, 255) 90%,
					rgb(255, 255, 255) 100%
				);
			}
		}
	}
</style>